import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { AnimateHeight, ChevronDownIcon } from '@blade/ui-kit'
import { QuickBuySectionsInputs } from '@root/features/trade/quick-buy/ui/quick-buy-sections-inputs'
import { ChargeIcon } from '@root/shared/ui-kit/icons'

import type { ClassNameProps } from '@root/shared/react'

type TradeSettingsQuickBuySectionsProps = {} & ClassNameProps

export const TradeSettingsQuickBuySections: React.FC<
  TradeSettingsQuickBuySectionsProps
> = ({ className }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  return (
    <Root className={className}>
      <Header onClick={() => setOpen(!open)}>
        <Icon />
        <Label>{t('table.quick_buy')}</Label>

        <Chevron data-open={open}>
          <ChevronDownIcon size={18} />
        </Chevron>
      </Header>
      <AnimateHeight>
        {open ? (
          <Sections key="sections">
            <QuickBuySectionsInputs />
          </Sections>
        ) : undefined}
      </AnimateHeight>
    </Root>
  )
}

const Root = styled.div``

const Icon = styled(ChargeIcon)`
  color: var(--primary-9);
`

const Label = styled.div`
  color: var(--text-12);

  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
`

const Chevron = styled.div`
  display: grid;
  justify-self: end;
  color: var(--text-11);
  transition:
    color 0.15s linear,
    transform 0.15s linear;

  &[data-open='true'] {
    transform: rotate(180deg);
  }
`

const Header = styled.div`
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  align-items: center;
  gap: 4px;

  padding-block: 10px;
  cursor: pointer;

  &:hover {
    ${Chevron} {
      color: var(--text-12);
    }
  }
`

const Sections = styled.div`
  padding-block: 10px;
  border-top: 1px solid var(--background-3);
`
